
export default function CtaSection() {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9196421d503b25fddef6bb72f8080034.jpg"
          alt="DMM FX口座開設 CTA背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-600/90 to-emerald-600/90"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
          <i className="ri-gift-line"></i>
          口座開設＋取引で最大30万円キャッシュバック
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          今すぐDMM FXで<br className="md:hidden" />取引を始めよう
        </h2>
        <p className="text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          口座開設は最短即日完了。スマホで簡単に申し込めます。<br />
          初心者でも安心のサポート体制で、あなたのFXデビューを応援します。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82"
            rel="nofollow"
            className="bg-white text-teal-700 px-10 py-4 rounded-lg text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-arrow-right-circle-line"></i>
            無料で口座開設する
          </a>
          <img border={0} width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" alt="" style={{ display: 'none' }} />
        </div>
        <div className="flex items-center justify-center gap-6 mt-8 text-white/70 text-xs">
          <span className="flex items-center gap-1"><i className="ri-shield-check-line"></i>口座開設無料</span>
          <span className="flex items-center gap-1"><i className="ri-time-line"></i>最短即日</span>
          <span className="flex items-center gap-1"><i className="ri-smartphone-line"></i>スマホ完結</span>
        </div>
      </div>
    </section>
  );
}
